import { render } from "./SucursalList.vue?vue&type=template&id=521e7777&scoped=true"
import script from "./SucursalList.vue?vue&type=script&lang=js"
export * from "./SucursalList.vue?vue&type=script&lang=js"

import "./SucursalList.vue?vue&type=style&index=0&id=521e7777&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521e7777"]])

export default __exports__